import Vue from 'vue';

import getEnvironmentVariable from '@/utils/get-environment-variable';
import router from '@/router';
import Auth0Plugin from './plugin';

const domain = getEnvironmentVariable('VUE_APP_AUTH0_DOMAIN');
const clientId = getEnvironmentVariable('VUE_APP_AUTH0_CLIENT_ID');

Vue.use(Auth0Plugin, {
  domain,
  clientId,
  onRedirectCallback(appState) {
    router.push(appState && appState.targetUrl ? appState.targetUrl : window.location.pathname);
  },
});
